export default __webpack_public_path__ + "static/media/child_care_blue.0cd043c2.svg";